import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CreateEmailtrigger, CreateEmailtriggerFailAction, CreateEmailtriggerSuccessAction } from './email-trigger.actions';
import { EmailDetailsModel, EmailTriggerClient } from '@core/services/api.service';
import { catchError, tap } from 'rxjs/operators';

export class EmailTriggerStateModel {
  public isLoading: boolean;
}

@State<EmailTriggerStateModel>({
  name: 'emailTrigger',
  defaults: {
    isLoading: false
  }
})
@Injectable()
export class EmailTriggerState {
  emailDetails: EmailDetailsModel;
  constructor(
    private emailTriggerService: EmailTriggerClient
  ) { }

  @Selector()
  static getEmailDetails(state: EmailTriggerState): EmailDetailsModel | null {
    return state.emailDetails;
  }

  @Selector()
  static getIsLoading(state: EmailTriggerStateModel) {
    return state.isLoading;
  }


  @Action(CreateEmailtrigger)
  createEmailTrigger({ dispatch, patchState } : StateContext<EmailTriggerState>, action: CreateEmailtrigger) {
    return this.emailTriggerService.createEmailDetails(action.tourId).pipe(
        tap((emailDetails) => {
            dispatch(new CreateEmailtriggerSuccessAction({ emailDetails }));
        }),
        catchError(error => {
            dispatch(new CreateEmailtriggerFailAction());
            throw error;
        })
    );
  }

  @Action(CreateEmailtriggerSuccessAction)
  getTourByIdSuccess({ dispatch, patchState } : StateContext<EmailTriggerState>, action: CreateEmailtriggerSuccessAction) {
    patchState({
      emailDetails: action.payload.emailDetails,
    });
  }

  @Action(CreateEmailtriggerFailAction)
  getTourByIdFail({ dispatch, patchState }: StateContext<EmailTriggerState>, action: CreateEmailtriggerFailAction) {
    patchState({
      emailDetails: null
    });
  }

}
